import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, freddyTheme, Link, Typography } from '@coolblue-development/freddy';
import { ArrowRight } from '@coolblue-development/icons';
import { Image } from '@coolblue-development/next-image/client';
import { hamburgerLinkStyles } from './HamburgerMenu.styles.js';
export default function HamburgerMenuRootItem({ item, onNavigateToChild, }) {
    return (_jsx(Link, { href: item.url, onClick: event => {
            event.preventDefault();
            onNavigateToChild();
        }, sx: hamburgerLinkStyles, children: _jsxs(Flex, { alignItems: "center", px: 300, gap: 300, sx: {
                borderTop: `${freddyTheme.borderWidth[25]} solid ${freddyTheme.color.border.base}`,
                minHeight: '5.2rem',
            }, children: [item.imageId && (_jsx(Image, { fileCollection: "content", imageId: item.imageId.toString(), alt: item.title, height: 42, width: 62, loading: "eager", objectFit: "cover", sx: { alignSelf: 'flex-end' } })), _jsx(Typography, { component: "span", children: item.title }), _jsx(Box, { marginLeft: "auto", children: _jsx(ArrowRight, { size: 12, fill: freddyTheme.color.icon.subtle }) })] }) }));
}
//# sourceMappingURL=HamburgerMenuRootItem.js.map